<template>
  <div class="stream-error" role="alert">
    <warning-outlined class="stream-error__icon" />
    <div class="stream-error__message">{{ message }}</div>
    <a-button type="primary" size="small" @click="$emit('retry')">
      <template #icon>
        <reload-outlined />
      </template>
      Retry
    </a-button>
  </div>
</template>

<script>
import { ReloadOutlined, WarningOutlined } from '@ant-design/icons-vue';

// Error state with a Retry button for the live stream screens.
export default {
  components: { ReloadOutlined, WarningOutlined },
  props: {
    message: { type: String, required: true },
  },
  emits: ['retry'],
};
</script>

<style scoped>
.stream-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px;
  text-align: center;
}
.stream-error__icon {
  font-size: 28px;
  color: #faad14;
}
.stream-error__message {
  max-width: 360px;
}
</style>
